export default () => ({
    bind: {
        [':class']() {
            return this.$store.cart.data.total.count ? 'active' : '';
        },

        ['@click']() {
            if (this.$store.cart.data.total.count > 0) {
                window.location = langSlug + '/order'
            }
        }
    }
})
